let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6CboQ")).then(() => parcelRequire('7YG4M'));